const createFontStyle = ({ font, size, clr, options = {} }) => {
  return {
    font: size + 'px ' + font,
    fill: clr,
    boundsAlignH: options.boundsAlignH || 'center',
    boundsAlignV: options.boundsAlignV || 'middle',
    ...options,
  };
};

export const createTextField = (game, font, size, clr, x, y, options = {}) => {
  const style = createFontStyle({
    font,
    size,
    clr,
    options,
  });
  return game.make.text(x, y, '', style);
};
